import { component } from 'picoapp';

export default component(async (node) => {
  const trigger = node.querySelector<HTMLButtonElement>('[data-share]');

  const getShareLink = (): string => {
    const { permaId } = window.WishlistKing.toolkit.collection.items[0];

    const params = {
      wkShareService: 'link',
      wkShare: permaId,
      wkShareImage: '',
    };

    const url = window.WishlistKing.toolkit.getShareLink(params);
    return url;
  };

  const copyLink = async () => {
    await navigator.clipboard.writeText(getShareLink());
    trigger.textContent = window.theme.strings.wishlist.share.copied;

    setTimeout(() => {
      trigger.textContent = window.theme.strings.wishlist.share.text;
    }, 3000);
  };

  trigger.addEventListener('click', copyLink);
  document.addEventListener('wishlist:ready', getShareLink);
});
